import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AuthManager from './utils/AuthManager';
import API from './services/API';
import LoginPage from './components/LoginPage';
import Dashboard from './components/Dashboard';
import DailyReportList from './components/daily-report/daily-report-list';
import DailyReportForm from './components/daily-report/daily-report-form';

// Chép khung từ PE_Form/App.js: AuthWrapper giữ phiên localStorage 30 ngày, truyền userInfo/accessToken/onLogout xuống trang.
// Bỏ: xem dưới tài khoản F1, khoá tính năng theo feature_configs, điểm thưởng (chưa có ở THM).
const AuthWrapper = ({ children }) => {
  const [state, setState] = useState({ loading: true, ok: false, userInfo: null, accessToken: null });

  const fetchProfile = useCallback(async (token) => {
    const r = await API.getUserProfile(token);
    if (r.success && r.user) {
      AuthManager.updateUserInfo(r.user);
      setState((s) => ({ ...s, userInfo: { ...s.userInfo, ...r.user } }));
    }
  }, []);

  useEffect(() => {
    const session = AuthManager.getSession();
    if (!session?.userInfo || AuthManager.isSessionExpired()) {
      AuthManager.clearSession();
      setState({ loading: false, ok: false, userInfo: null, accessToken: null });
      return;
    }
    AuthManager.refreshSession();
    setState({ loading: false, ok: true, userInfo: session.userInfo, accessToken: session.accessToken });
    fetchProfile(session.accessToken);
  }, [fetchProfile]);

  // feature-api.js phát 'auth:expired' khi API trả 401
  useEffect(() => {
    const onExpired = () => {
      AuthManager.clearSession();
      window.location.href = `/login?redirect=${encodeURIComponent(window.location.pathname)}`;
    };
    window.addEventListener('auth:expired', onExpired);
    return () => window.removeEventListener('auth:expired', onExpired);
  }, []);

  const handleLogout = () => {
    AuthManager.clearSession();
    window.location.href = '/login';
  };

  if (state.loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-brand-50 to-brand-100 flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-brand-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!state.ok) return <Navigate to={`/login?redirect=${encodeURIComponent(window.location.pathname)}`} replace />;

  return React.cloneElement(children, { userInfo: state.userInfo, accessToken: state.accessToken, onLogout: handleLogout });
};

const LoginWrapper = () => {
  const redirect = new URLSearchParams(window.location.search).get('redirect') || '/dashboard';
  useEffect(() => {
    const session = AuthManager.getSession();
    if (session && !AuthManager.isSessionExpired()) window.location.href = redirect;
  }, [redirect]);
  return <LoginPage onLogin={(userInfo, accessToken) => { AuthManager.saveSession(userInfo, accessToken); window.location.href = redirect; }} />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginWrapper />} />
        <Route path="/dashboard" element={<AuthWrapper><Dashboard /></AuthWrapper>} />
        <Route path="/bao-cao-ngay" element={<AuthWrapper><DailyReportList /></AuthWrapper>} />
        <Route path="/bao-cao-ngay/tao-moi" element={<AuthWrapper><DailyReportForm /></AuthWrapper>} />
        <Route path="/bao-cao-ngay/chinh-sua" element={<AuthWrapper><DailyReportForm /></AuthWrapper>} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
